import React from "react";
import { Anchor } from "antd";
import { CircleFocus } from "./CircleFocus";
import { Circle } from "./Circle";
import "./style.css";

const { Link } = Anchor;

export class RightMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = { page: "" };
  }

  render() {
    return (
      <div className="circles">
        <Anchor
          affix={false}
          onChange={(link) => {
            this.setState({ page: link });
            // window.location.hash = link;
          }}
          showInkInFixed={true}
        >
          <Link href="#home" title="">
            <div className="circleone">
              <div
                className={
                  this.state.page === "#home" || this.state.page === ""
                    ? ""
                    : "not_focus"
                }
              >
                <CircleFocus />
              </div>
              <a className="right_a" href="#home">
                <Circle />
              </a>
            </div>
          </Link>
          <Link href="#news" title="">
            <div className="circletwo">
              <div className={this.state.page === "#news" ? "" : "not_focus"}>
                <CircleFocus />
              </div>
              <a className="right_a" href="#news">
                <Circle />
              </a>
            </div>
          </Link>
          <Link href="#datas" title="">
            <div className="circlethree">
              <div className={this.state.page === "#datas" ? "" : "not_focus"}>
                <CircleFocus />
              </div>
              <a className="right_a" href="#datas">
                <Circle />
              </a>
            </div>
          </Link>
          <Link href="#techs" title="">
            <div className="circlefour">
              <div className={this.state.page === "#techs" ? "" : "not_focus"}>
                <CircleFocus />
              </div>
              <a className="right_a" href="#techs">
                <Circle />
              </a>
            </div>
          </Link>
          <Link href="#contact" title="">
            <div className="circlefive">
              <div
                className={this.state.page === "#contact" ? "" : "not_focus"}
              >
                <CircleFocus />
              </div>
              <a className="right_a" href="#contact">
                <Circle />
              </a>
            </div>
          </Link>
        </Anchor>
      </div>
    );
  }
}
